module.exports = __webpack_public_path__ + "static/Broadcaster-34ff79673a842e0f8af0b4f870885554.png";